$(document).ready(function () {

  if (!$('.swiper-main-product').hasClass('no-swipe')) {
    const pdpMainSwiper = new Swiper ('.swiper-main-product', {
      loop: false,
      slidesPerView: 1,
      centeredSlides: true,
      grabCursor: true,
      freeMode: false,
      spaceBetween: 0,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button--next',
        prevEl: '.swiper-button--prev',
      },
      breakpoints: {
        750: {
          slidesPerView: 1,
        }
      }
    });

    const pdpThumbsSwiper = new Swiper ('.swiper-thumbnails', {
      loop: false,
      slidesPerView: 'auto',
      navigation: {
        nextEl: '.swiper-next',
        prevEl: '.swiper-prev',
      },
    });

    $('.swiper-thumbnails').on('click', '.swiper-slide button', function () {
      const index = parseInt($(this).closest('li').attr('data-media-position'));
      pdpMainSwiper.slideTo(index - 1);
      $(this).closest('.swiper-thumbnails').find('button').attr('aria-current', false);
      $(this).attr('aria-current', true);
    });

    pdpMainSwiper.on('slideChange', function () {
      $('.swiper-thumbnails').find('button').attr('aria-current', false);
      $('.swiper-thumbnails .swiper-slide').eq(pdpMainSwiper.activeIndex ).find('button').attr('aria-current', true);
    });

  }


  // Create our number formatter.
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  $('.js-quantity-input').on('change', function () {
    var selectedQuantity = parseFloat($(this).val());
    const $productForm = $(this).closest('.js-product-add-wrap');
    var $priceInput = $productForm.find('.js-price-change-w-quantity');
    var variantPrice = parseFloat($productForm.find('.js-variant-id').attr('data-raw-price'));
    var variantPriceTimesQuantity = formatter.format((selectedQuantity * variantPrice / 100)).replace(/\D00(?=\D*$)/, '');

    $priceInput.html(variantPriceTimesQuantity);
  });

})
